import { iconCredit, } from '../defaultValues';

const data = {
    role_1c0be36b19b843fd90caa5556c530ef3: [
        {
            id: 'solicitudes-credito',
            icon: iconCredit,
            label: 'Solicitudes',
            to: '/app/credits',
        },
       
    ],
};
export default data;
